export default [{
                              fontFamily: 'FontAwesome',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/FontAwesome.ttf'),
                          },{
                              fontFamily: 'MaterialIcons',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/MaterialIcons.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-Bold',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-Bold.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-BoldItalic',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-BoldItalic.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-Medium',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-Medium.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-MediumItalic',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-MediumItalic.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-Regular',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-Regular.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-RegularItalic',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-RegularItalic.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-Thin',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-Thin.ttf'),
                          },{
                              fontFamily: 'TeleGroteskNext-Ultra',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TeleGroteskNext-Ultra.ttf'),
                          },{
                              fontFamily: 'TimeBurner',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/TimeBurner.ttf'),
                          },{
                              fontFamily: 'password',
                              file: require('/Users/janpetrik/Node/24i/prj-1260-stl-nxg-marino/appConfigs/base/fonts/password.ttf'),
                          },];